
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import OpenChatReportApi from '@/api/OpenChatReportApi';
import { getTodayNowTime, getTodayStartTime } from '@/utils/date.util';

export default defineComponent({
  setup () {
    let timer = 0
    const max = ref(0)
    const rankList = ref<any []>([])
    function chatServiceDeskCountReport () {
      OpenChatReportApi.chatServiceDeskCountReport({
        startDate: getTodayStartTime(),
        endDate: getTodayNowTime(),
        top: 5
      }).then((res:any) => {
        const data = (res && res.length > 0 && !!res) ? res[0] : {
          serviceDesks: []
        }
        rankList.value = data.serviceDesks.sort((a, b) => b.count - a.count).slice(0, 5)
        max.value = data.serviceDesks.length > 0 ? rankList.value[0].count : 0
        timer = setTimeout(() => {
          chatServiceDeskCountReport()
        }, 10000);
      })
    }
    onMounted(() => {
      chatServiceDeskCountReport()
    })

    onBeforeUnmount(() => {
      clearTimeout(timer);
    })
    
    return {
      max,
      rankList
    }
  }
})
